import { createContext, useContext, useEffect, useMemo, useState } from "react";
import en from "./en.json";
import hi from "./hi.json";
import de from "./de.json";
import fr from "./fr.json";
import es from "./es.json";
import it from "./it.json";
import ru from "./ru.json";
import nl from "./nl.json";

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "hi", label: "हिन्दी", short: "हि" },
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "es", label: "Español", short: "ES" },
  { code: "it", label: "Italiano", short: "IT" },
  { code: "ru", label: "Русский", short: "RU" },
  { code: "nl", label: "Nederlands", short: "NL" },
];

const DICTS = { en, hi, de, fr, es, it, ru, nl };

const merge = (base, over) => {
  if (Array.isArray(base)) return Array.isArray(over) && over.length === base.length ? base.map((b, i) => merge(b, over[i])) : base;
  if (base && typeof base === "object") {
    return Object.fromEntries(Object.keys(base).map((k) => [k, merge(base[k], over?.[k])]));
  }
  return typeof over === typeof base && over !== "" ? over : base;
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("vya-lang");
    return DICTS[saved] ? saved : "en";
  });
  useEffect(() => {
    localStorage.setItem("vya-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useMemo(() => merge(en, DICTS[lang]), [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
